// FSRS v5 weights, calibrated for StudyQuantifier.
// w[8] is reduced from canonical 1.616 to 0.4 to slow the
// exponential growth of stability. With 2-rating mode the user
// almost always rates "Good" for successful recalls, and the
// canonical weights produce intervals that exceed the brief's
// pedagogical expectations (A7: 8-20 days after 3 Goods).
export const FSRS_V5_DEFAULT_WEIGHTS: readonly number[] = [
  0.4072, 1.1829, 3.1262, 15.4722,
  7.2102, 0.5316, 1.0651, 0.0234,
  0.4, 0.1544, 1.0824, 1.9813,
  0.0953, 0.2975, 2.2042, 0.2407,
  2.9466, 0.5034, 0.6567
] as const;

export const DEFAULT_RETENTION_TARGET = 0.90;
export const MAXIMUM_INTERVAL_DAYS = 365;